import type { CalendarPermissionLevel } from "@app/analytics/types";
import { put, get, ApiOptions } from "@app/common/api";
import type { UserRssLinkSettings, UserSettings } from "@app/common/types";
import type { CalendarProviderId } from "@app/common/types/providerTypes";

export interface EmailPreference {
  groupName: string;
  groupId: number;
  description: string;
  isSubscribed: boolean;
}

export interface EmailPreferenceCategory {
  category: string;
  groupStates: EmailPreference[];
}

export interface EmailPreferences {
  preferences: EmailPreferenceCategory[];
}

export type UpdateRssLinkSettingsBody = Partial<UserRssLinkSettings> & {
  calendarProvider?: CalendarProviderId;
};

export type UpdateUserSettingsBody = Partial<
  Omit<UserSettings, "rssLinkSettings">
> & {
  rssLinkSettings?: UpdateRssLinkSettingsBody;
};

export const updateCalendarPrefs = async (pref: CalendarPermissionLevel) => {
  const prefs = { permissionLevel: pref };
  return await put(`/users/me/calendar`, prefs, { withCreds: true });
};

export const updateUserSettings = async (
  userSettings: UpdateUserSettingsBody,
  options?: ApiOptions
) =>
  await put("/users/me/settings", userSettings, {
    withCreds: true,
    ...options,
  });

export const getEmailPreferences = async (): Promise<EmailPreferences> => {
  return await get("/users/settings/email-preferences", { withCreds: true });
};

export const updateEmailPreferences = async (body: any) => {
  return await put("/users/settings/email-preferences", body, {
    withCreds: true,
  });
};
